import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import DebouncedButton from '@common/components/DebouncedButton';

interface Props {
  onConfirm: () => void;
  onBack: () => void;
}

const ConfirmMonthToMonth = ({ onConfirm, onBack }: Props) => (
  <Container>
    <Row>
      <Col>
        <Text type="h3">Are you sure you want to switch to month-to-month?</Text>
        <Text>
          This change will take effect immediately and you will no longer have an end date. We&apos;ll notify your
          tenant.
        </Text>
      </Col>
    </Row>
    <Row>
      <Col>
        <DebouncedButton full type="primary" onClick={onConfirm}>
          Yes, change end date
        </DebouncedButton>
      </Col>
    </Row>
    <Row>
      <Col>
        <Button full type="tertiary" onClick={onBack}>
          Nevermind, go back
        </Button>
      </Col>
    </Row>
  </Container>
);

export default ConfirmMonthToMonth;
